/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { MsoDefaultBrandingUiBundleServiceRepositoryImpl } from '../impls/MsoDefaultBrandingUiBundleServiceRepositoryImpl';
import { IMsoDefaultBrandingUiBundleServiceRepository } from '../interfaces/IMsoDefaultBrandingUiBundleServiceRepository';

export class MsoDefaultBrandingUiBundleService
    implements IMsoDefaultBrandingUiBundleServiceRepository
{
    private oMsoDefaultBrandingUIServiceRepository: MsoDefaultBrandingUiBundleServiceRepositoryImpl;

    constructor() {
        this.oMsoDefaultBrandingUIServiceRepository =
            new MsoDefaultBrandingUiBundleServiceRepositoryImpl();
    }

    static initialize(baseUrl: string) {
        MsoDefaultBrandingUiBundleServiceRepositoryImpl.initialize(baseUrl);
    }

    async fetchMsoDefaultBrandingUiInfo(): Promise<void> {
        return this.oMsoDefaultBrandingUIServiceRepository.fetchMsoDefaultBrandingUiInfo();
    }

    getBrandingUiInfoForKey(key: string): any {
        return this.oMsoDefaultBrandingUIServiceRepository.getBrandingUiInfoForKey(key);
    }
}
